$ = require 'jquery'
Action = require 'models/action'
Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
Board = require 'models/board'
Card = require 'models/card'
Controller = require 'controller'
Dates = require 'lib/dates'
Highlight = require 'views/home/highlight'
List = require 'models/list'
ModelLoader = require 'db/model-loader'
NewUserOrientationCard = require 'views/home/new-user-orientation-card'
Organization = require 'models/organization'
Promise = require 'bluebird'
React = require 'react'
TFM = require 'lib/markdown/tfm'
UndoDismissSnackbar = require 'views/home/undo-dismiss-snackbar'
UpNext = require 'views/home/up-next'
Util = require 'lib/util'
_ = require 'underscore'
startDecayingInterval = require 'lib/util/decaying-interval'
t = require('views/internal/recup-with-helpers')('home')
trackUe = require 'debug/trackUe'
{ ContentSkeleton } = require 'views/home/presentational/content-skeleton'
{ FixedSectionHeaderButton } = require './presentational/section-header'
{ HighlightSection } = require './presentational/highlight-section'
{ OrientationCard } = require './presentational/orientation-card'
{ UpNextSection } = require './presentational/up-next-section'
{ getScrollParent } = require 'common/lib/dom/get-scroll-parent'
{ trackUnsplashViewBySavedUrl } = require 'network/unsplash'

MAX_PAGE_RESULTS = 20

module.exports = class HomeMainContentContainer extends React.Component
  displayName: 'HomeMainContentContainer'

  constructor: (props) ->
    super props

    { orgname, modelCache } = @props

    @dismissTimeout = null
    @unresolvedPromises = new Set()
    @onHomeTab = !orgname # no orgname means it's on home tab
    @currentOrg = modelCache.findOne('Organization', 'name', orgname)
    @currentOrgId = @currentOrg?.id

    @getOrientationDisplayFlags = @getOrientationDisplayFlags.bind(@)
    @updateUpNextCards = @updateUpNextCards.bind(@)
    @fetchUpNextCards = @fetchUpNextCards.bind(@)
    @startPollingForUpNextCards = @startPollingForUpNextCards.bind(@)
    @optimisticallyDismissCard = @optimisticallyDismissCard.bind(@)
    @dismissUpNextOrientationCard = @dismissUpNextOrientationCard.bind(@)
    @dismissUpNextCard = @dismissUpNextCard.bind(@)

    @fetchHighlights = @fetchHighlights.bind(@)
    @pollHighlights = @pollHighlights.bind(@)
    @startPollingforHighlights = @startPollingforHighlights.bind(@)
    @showUnreadHighlights = @showUnreadHighlights.bind(@)
    @showNewUpNextItems = @showNewUpNextItems.bind(@)
    @loadMoreHighlights = @loadMoreHighlights.bind(@)
    @dismissHighlightsOrientationCard = @dismissHighlightsOrientationCard.bind(@)

    @dismissNewUser = @dismissNewUser.bind(@)
    @createBoard = @createBoard.bind(@)

    @state = {
      fixedButtons: {}
      idActions: []
      initialHighlightsLoad: false
      initialUpNextLoad: false
      isFirstBoard: false
      loadingMore: false
      moreHighlightsAvailable: false
      mostRecentActionId: ''
      mostRecentDismissedUpNext: null
      newUpNextCards: []
      newUserCanDismiss: false
      numUpNextCardsVisible: 1
      shouldShowUndoDismiss: false
      showNewUserCard: false
      showUnreadActionsButton: false
      unreadIdActions: []
      upNextCards: []
      upNextOptimisticallyUpdated: false
    }

  componentDidMount: ->
    @cancelOnUnmount(new Promise((resolve) -> ModelLoader.waitFor('boardsData', resolve))).then =>
      { newUserCanDismiss, showNewUserCard, isFirstBoard } = @getOrientationDisplayFlags()

      @setState
        isFirstBoard: isFirstBoard
        showNewUserCard: showNewUserCard
        newUserCanDismiss: newUserCanDismiss

      if !showNewUserCard
        if @onHomeTab
          @fetchUpNextCards().then (upNextCards) =>
            @setState
              upNextCards: upNextCards
              initialUpNextLoad: true
            @startPollingForUpNextCards()
          .catch (e) =>
            if e instanceof Promise.CancellationError
              throw e
            @setState
              initialUpNextLoad: true
        else
          @setState
            initialUpNextLoad: true

        @fetchHighlights({}).then (idActions) =>
          @setState
            idActions: idActions
            mostRecentActionId: if idActions?.length then idActions[0] else ''
            initialHighlightsLoad: true
          @startPollingforHighlights()
        .catch (e) =>
          if e instanceof Promise.CancellationError
            throw e
          @setState
            initialHighlightsLoad: true

      else
        @setState
          initialUpNextLoad: true
          initialHighlightsLoad: true

  componentWillUnmount: ->
    if @cancelUpNextDecayingInterval
      @cancelUpNextDecayingInterval()

    if @cancelHighlightsDecayingInterval
      @cancelHighlightsDecayingInterval()

    if @dismissTimeout
      clearTimeout(@dismissTimeout)

    @unresolvedPromises.forEach((promise) -> promise.cancel())

  componentWillReceiveProps: ->
    me = Auth.me()
    isDismissed = if @currentOrgId then me.isDismissed("homeNewUserCard_#{@currentOrgId}") else me.isDismissed('homeNewUserCard')
    if @state.showNewUserCard && isDismissed
      @setState(showNewUserCard: false)

  componentDidUpdate: ->
    @setDateFirstSawHighlights()

  cancelOnUnmount: (promise) =>
    promise.cancellable()
    @unresolvedPromises.add(promise)
    promise.then => @unresolvedPromises.delete(promise)

    return promise

  getOrientationDisplayFlags: ->
    me = Auth.me()
    ownedBoards = _.filter me.boardList.models, (board) -> board.owned()
    openBoards = _.filter me.boardList.models, (board) -> board.isOpen()
    orgsMemberOf = _.filter me.organizationList.models, (member) -> member.isMember(me)

    # Only has a welcome boards or no boards at all
    isFirstBoard = ownedBoards.filter((board) => !board.isWelcomeBoard()).length == 0

    if !@currentOrgId && me.isDismissed('homeNewUserCard')
      return { newUserCanDismiss: false, showNewUserCard: false, isFirstBoard }

    else if @currentOrgId
      if me.isDismissed("homeNewUserCard_#{@currentOrgId}")
        return { newUserCanDismiss: false, showNewUserCard: false, isFirstBoard }

      openOrgBoards = openBoards.filter((board) => board.getOrganization()?.id == @currentOrgId)
      if openOrgBoards.length == 0
        return { newUserCanDismiss: true, showNewUserCard: true, isFirstBoard }
      else
        return { newUserCanDismiss: false, showNewUserCard: false, isFirstBoard }

    else if isFirstBoard
      return { newUserCanDismiss: true, showNewUserCard: true, isFirstBoard }

    else
      return { newUserCanDismiss: false, showNewUserCard: false, isFirstBoard }

  getVisibleUpNexts: (upNexts) ->
    upNexts.filter(({ dismissed }) -> !dismissed)

  getUpNextById: (upNexts, upNextId) ->
    upNexts.find(({ id }) -> id == upNextId)

  # Up Next Functions Start
  unsplashTrackNewUpNext: (newIds, allCards) ->
    trackingPaths = allCards.filter((card) => newIds.includes(card.id)).map((card) => card.board.attributes.prefs.backgroundImage)
    trackUnsplashViewBySavedUrl(trackingPaths.filter (tp) -> !!tp)

  renderUpNext: (upNextCard) =>
    { id, card, list, board, org, item } = upNextCard
    React.createElement UpNext, {
      @dismissUpNextCard
      @optimisticallyDismissCard
      board
      card
      item
      key: id
      list
      modelCache: @props.modelCache
      org
      setFocusedCard: @props.setFocusedCard
      upNextId: id
    }

  updateUpNextCards: (callback) ->
    @fetchUpNextCards().then (upNextCards) =>
      @setState((prevState, props) =>
        currUpNextIds = @getVisibleUpNexts(prevState.upNextCards).map((card) => card.id)
        newUpNextIds = @getVisibleUpNexts(upNextCards).map((card) => card.id)
        isNewUpNext = !_.isEqual(currUpNextIds, newUpNextIds)

        if isNewUpNext
          @unsplashTrackNewUpNext(newUpNextIds, upNextCards)
          return { newUpNextCards: upNextCards }

      , callback)

  fetchUpNextCards: ->
    { modelCache } = @props

    @cancelOnUnmount(ModelLoader.loadUpNext())
      .then (response) =>
        upNextCards = response.upNext.map (upNextItem) =>
          card = _.findWhere response.cards, id: upNextItem.data.idCard
          list = _.findWhere response.lists, id: card.idList
          board = _.findWhere response.boards, id: card.idBoard
          item = upNextItem.items[0] # for initial release there is only 1 item
          action = _.findWhere response.actions, id: item.data.idAction
          memberCreator = _.findWhere response.members, id: action?.idMemberCreator
          org = _.findWhere response.organizations, id: board.idOrganization

          action?.memberCreator = memberCreator
          board.organization = org
          card.list = list
          card.board = board
          item.data = { action }
          new Card(card, modelCache: modelCache)

          return {
            id: upNextItem.id
            card: modelCache.get('Card', card.id)
            list: new List(list, modelCache: modelCache)
            board: new Board(board, modelCache: modelCache)
            org: new Organization(org, modelCache: modelCache)
            dismissed: false
            item
          }

        return upNextCards

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  startPollingForUpNextCards: ->
    @cancelUpNextDecayingInterval = startDecayingInterval =>
      @setState (prevState) =>
        if prevState.upNextOptimisticallyUpdated
          # Skip one poll result if the user made an API request
          # within the last poll. This prevents stale data from
          # overwriting the client-side optimistic dismissing before
          # the API request finishes.
          return { upNextOptimisticallyUpdated: false }
        else
          @updateUpNextCards()
          return

  onShowMoreUpNextClick: =>
    trackUe('home', 'shows more', 'cards', '', '', 'by clicking show more in up next feed')
    @setState (prevState, props) ->
      numUpNextCardsVisible: prevState.numUpNextCardsVisible + 6

  showNewUpNextItems: (e) ->
    Util.preventDefault(e)

    method = 'by clicking load new items button in up next feed'
    context = {}

    if @currentOrgId
      method = 'by clicking load new items button in up next feed when filtered by team'
      Object.assign(context, { teamId: @currentOrgId })

    trackUe('home', 'loads more', 'cards', '', '', method, context)

    @setState (prevState, props) ->
      upNextCards: prevState.newUpNextCards
      newUpNextCards: []

  optimisticallyDismissCard: (upNextId, dismissed = true, delay = true) ->
    # optimistically dismiss card with a slight delay
    dismiss = =>
      @setState (prevState, props) ->
        mapUpNext = (upNext) ->
          if upNext.id != upNextId
            upNext
          else
            Object.assign({}, upNext, {
              dismissed: dismissed
            })

        upNextCards = prevState.upNextCards.map(mapUpNext)
        newUpNextCards = prevState.newUpNextCards.map(mapUpNext)

        if upNextCards.length == 0 && newUpNextCards.length > 0
          # if it's the last card that we dismissed and there are new cards that we can show let's show the
          return {
            upNextCards: newUpNextCards
            newUpNextCards: []
          }

        return {
          upNextCards
          newUpNextCards
        }

    if delay
      @dismissTimeout = setTimeout(dismiss, 250)
    else
      dismiss()

    @setState upNextOptimisticallyUpdated: true

  dismissUpNextOrientationCard: ->
    trackUe('home', 'dismisses', 'intro component', 'on up next feed', '', 'by clicking dismiss link in up next intro card')
    Auth.me().dismiss('homeUpNextOrientationCard')

  dismissUpNextCard: (cardId, upNextId, trackingPrepositionalObject) ->
    trackUe('home', 'dismisses', 'card', trackingPrepositionalObject, '', 'by clicking dismiss button in up next card', { cardId: cardId })
    @optimisticallyDismissCard(upNextId, true)

    @setState (prevState) =>
      mostRecentDismissedUpNext: @getUpNextById(prevState.upNextCards, upNextId)
      shouldShowUndoDismiss: true

    @cancelOnUnmount(ApiPromise
      url: "1/members/me/upNext/#{upNextId}"
      type: "PUT"
      data:
        dismissed: true
    ).done()

  undoDismissUpNext: (upNextId) =>
    cardId = @getUpNextById(@state.upNextCards, upNextId)?.card?.id
    trackUe('home', 'undismisses', 'card', '', '', 'by clicking undo button in snackbar', { cardId: cardId })

    @optimisticallyDismissCard(upNextId, false)

    @cancelOnUnmount(ApiPromise
      url: "1/members/me/upNext/#{upNextId}"
      type: "PUT"
      data:
        dismissed: false
    ).done()

  closeUndoDismissUpNext: =>
    @setState(shouldShowUndoDismiss: false)
  # Up Next Functions End

  # Highlights Functions Start
  fetchHighlights: ({ before, since }) ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    if (orgname && !orgId)
      # if there is no orgId when there is an orgname it means that you no longer can see that team
      # this fixes an issue when you're deactivated from a team, but the update to the model hasn't
      # flown down and redirected the page, so we make a bad request by fetching highlights for that team
      return new Promise (resolve) -> []

    @cancelOnUnmount(ModelLoader.loadHighlights({ before, since, organization: orgId }))
      .then (response) =>
        trackingPaths = []
        highlightCards = response.highlights.map (action) =>
          card = _.findWhere response.cards, id: action.data.card.id
          list = _.findWhere response.lists, id: card.idList
          board = _.findWhere response.boards, id: card.idBoard
          org = _.findWhere response.organizations, id: board.idOrganization

          board.organization = org
          card.list = list
          card.board = board
          action.card = card
          action.list = list
          action.board = board

          if board.prefs.backgroundImage?
            trackingPaths.push(board.prefs.backgroundImage)

          # Side effect: Action gets loaded into modelCache.
          action = new Action(action, modelCache: modelCache)
          return action.id

        trackUnsplashViewBySavedUrl trackingPaths

        @setState (prevState) ->
          moreHighlightsAvailable: prevState.moreHighlightsAvailable || highlightCards.length == MAX_PAGE_RESULTS

        return highlightCards

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  pollHighlights: ->
    { modelCache } = @props
    @fetchHighlights({ since: @state.mostRecentActionId }).then (newIdActions) =>
      if newIdActions.length
        # are there actions from not the current user
        isActionsFromOtherUsers = newIdActions.some (actionId) ->
          action = modelCache.get('Action', actionId)
          memberCreator = modelCache.get('Member', action.get('idMemberCreator'))
          !Auth.isMe(memberCreator)

        @setState (prevState, props) ->
          showUnreadActionsButton: isActionsFromOtherUsers || prevState.showUnreadActionsButton
          unreadIdActions: newIdActions.concat prevState.unreadIdActions
          mostRecentActionId: newIdActions[0]

  startPollingforHighlights: ->
    @cancelHighlightsDecayingInterval = startDecayingInterval(@pollHighlights)

  showUnreadHighlights: (e) ->
    Util.preventDefault(e)

    method = 'by clicking load new activity button in highlights feed'
    context = {}

    if @currentOrgId
      method = 'by clicking load new activity button in highlights feed when filtered by team'
      Object.assign(context, { teamId: @currentOrgId })

    trackUe('home', 'loads more', 'cards', '', '', method, context)

    @setState (prevState, props) ->
      idActions: prevState.unreadIdActions.concat prevState.idActions
      unreadIdActions: []
      mostRecentActionId: prevState.unreadIdActions[0]
      showUnreadActionsButton: false

  loadMoreHighlights: (e) ->
    Util.preventDefault(e)

    method = 'by clicking show more activity in highlights feed'
    context = {}

    if @currentOrgId
      method = 'by clicking show more activity in highlights feed when filtered by team'
      Object.assign(context, { teamId: @currentOrgId })

    trackUe('home', 'shows more', 'cards', '', '', method, context)

    @setState
      loadingMore: true
    @fetchHighlights({ before: @state.idActions[@state.idActions.length - 1] }).then (idActions) =>
      @setState (prevState, props) ->
        idActions: prevState.idActions.concat(idActions)
        moreHighlightsAvailable: idActions.length == MAX_PAGE_RESULTS
        loadingMore: false
    .catch (e) =>
      if e instanceof Promise.CancellationError
        throw e
      @setState
        loadingMore: false

  dismissHighlightsOrientationCard: ->
    method = 'by clicking dismiss button in highlights intro card'
    context = {}

    if @currentOrgId
      method = 'by clicking dismiss button in highlights intro card when filtered by team'
      Object.assign(context, { teamId: @currentOrgId })

    trackUe('home', 'dismisses', 'intro component', 'on highlights feed', '', method, context)
    Auth.me().dismiss('homeHighlightsOrientationCard')

  dismissFeedbackOrientationCard: ->
    Auth.me().dismiss('homeFeedbackOrientationCard')

  setDateFirstSawHighlights: ->
    { idActions } = @state
    if idActions.length && !Auth.me().getDateFirstSawHighlights()
      Auth.me().setDateFirstSawHighlights()

  dismissHighlightsCard: (idAction) =>
    @setState (prevState) ->
      actions: prevState.actions.filter (id) -> id != idAction
  # Highlights Functions End

  dismissNewUser: ->
    dismissKey = if @currentOrgId then "homeNewUserCard_#{@currentOrgId}" else 'homeNewUserCard'
    Auth.me().dismiss(dismissKey)

  setHighlightsFixedButton: (shouldShow) =>
    @setState ({ fixedButtons }) ->
      fixedButtons: Object.assign({}, fixedButtons, highlights: shouldShow)

  setUpNextFixedButton: (shouldShow) =>
    @setState ({ fixedButtons }) ->
      fixedButtons: Object.assign({}, fixedButtons, upNext: shouldShow)

  setHighlightsWrapperRef: (ref) =>
    @ref ?= {}
    @ref.highlights = ref

  setUpNextWrapperRef: (ref) =>
    @ref ?= {}
    @ref.upNext = ref

  shouldShowFixedButton: ->
    { fixedButtons } = @state
    return fixedButtons.upNext || fixedButtons.highlights

  onClickFixedButton: =>
    scrollIntoView = (el) ->
      $(getScrollParent(el)).animate({
        scrollTop: el.offsetTop - 8
      })

    if @state.fixedButtons.upNext && @ref.upNext
      scrollIntoView(@ref.upNext)
    else if @state.fixedButtons.highlights && @ref.highlights
      scrollIntoView(@ref.highlights)

    @setState(fixedButtons: {})

    category = 'home'
    verb = 'scrolls to top'
    direct_object = 'activity feed'
    prepositional_object = ''
    indirect_object = if @currentOrgId then 'on team tab' else 'on boards tab'
    method = 'by clicking fixed new activity button'
    context = if @currentOrgId then { teamId: @currentOrgId } else ''

    trackUe(category, verb, direct_object, prepositional_object, indirect_object, method, context)

  createBoard: ({ name, trackingOpts }) ->
    # can only create a private personal board
    # so setting idOrganization, prefs_permissionLevel, and prefs_selfJoin to defaults

    { isFirstBoard } = @state

    # Data that we'll use in the body of the POST to create the board
    initialData = {
      name
      idOrganization: ''
    }

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: false
      defaultLists: isFirstBoard
    }, initialData)

    newBoard = Auth.me().boardList.create initialData, {
      @modelCache
      requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        boardId = board.get('id')

        if boardId !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(boardId))

        { category, method } = trackingOpts
        trackUe(category, 'adds', 'board', '', '', method, { boardId })

        # We have to wait until we get the board id back before we can
        # display the board
        Controller.displayBoard({
          idBoard: boardId
          openListComposer: !isFirstBoard
          openCardComposerInFirstList: isFirstBoard
        }).done()

        return
      error: ->
        Alerts.flash('could not create board', 'error', 'create error')
    }

  renderHighlight: (idAction) =>
    React.createElement Highlight, {
      @currentOrgId
      key: idAction
      idAction: idAction
      modelCache: @props.modelCache
      setFocusedCard: @props.setFocusedCard
      onDismissClick: @dismissHighlightsCard
    }

  render: t.renderable ->
    {
      idActions
      initialHighlightsLoad
      initialUpNextLoad
      loadingMore
      moreHighlightsAvailable
      mostRecentDismissedUpNext
      newUpNextCards
      numUpNextCardsVisible
      newUserCanDismiss
      shouldShowUndoDismiss
      showNewUserCard
      showUnreadActionsButton
      upNextCards
      unreadIdActions
    } = @state

    t.div '.home-main-content-container', =>
      t.tag FixedSectionHeaderButton,
        shouldShow: @shouldShowFixedButton()
        onClick: @onClickFixedButton
        iconName: 'up'
      , ->
        t.format 'new-activity'

      t.tag UndoDismissSnackbar,
        shouldShow: shouldShowUndoDismiss
        idDismiss: mostRecentDismissedUpNext?.id
        boardName: mostRecentDismissedUpNext?.board?.get('name')
        cardUrl: mostRecentDismissedUpNext?.card?.get('url')
        close: @closeUndoDismissUpNext
        undo: @undoDismissUpNext

      if showNewUserCard
        t.tag NewUserOrientationCard, {
          key: 'new-user'
          @onHomeTab
          @currentOrg
          modelCache: @props.modelCache
          onCreateBoardClick: @createBoard
          onDismissClick: if newUserCanDismiss then @dismissNewUser
        }

      else
        if !initialUpNextLoad || !initialHighlightsLoad
          t.div ->
            t.tag ContentSkeleton

        else
          if !@getVisibleUpNexts(upNextCards).length && !idActions.length
            t.tag OrientationCard, {
              key: 'orientation'
              titleKey: 'orientation-no-content-title'
              textKey: 'orientation-no-content-text'
              backgroundName: 'no-content'
              isBackgroundTop: true
            }

          else
            if @onHomeTab
              t.div '.home-main-content-item', { ref: (el) =>
                Dates.update(el)
                @setUpNextWrapperRef(el)
              }, =>
                t.tag UpNextSection, {
                  @dismissUpNextOrientationCard
                  @onShowMoreUpNextClick
                  @renderUpNext
                  @showNewUpNextItems
                  key: 'up-next'
                  modelCache: @props.modelCache
                  newUpNextCards: @getVisibleUpNexts(newUpNextCards)
                  numUpNextCardsVisible
                  setFixedButton: @setUpNextFixedButton
                  shouldShowUpNextOrientationCard: !Auth.me().isDismissed('homeUpNextOrientationCard')
                  upNextCards: @getVisibleUpNexts(upNextCards)
                }

            t.div '.home-main-content-item', { ref: @setHighlightsWrapperRef }, =>
              t.tag HighlightSection, {
                key: 'highlights'
                myId: Auth.myId()
                idActions
                unreadIdActions
                loadingMore
                @loadMoreHighlights
                moreHighlightsAvailable
                @showUnreadHighlights
                @dismissHighlightsOrientationCard
                @dismissFeedbackOrientationCard
                showUnreadActionsButton
                shouldShowHighlightsOrientationCard: !Auth.me().isDismissed('homeHighlightsOrientationCard')
                shouldShowFeedbackOrientationCard: false && Auth.me().shouldShowFeedbackCard() # only disable for now, leave for future use
                idOrganization: @currentOrgId
                @renderHighlight
                setFixedButton: @setHighlightsFixedButton
              }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-main-content-container.coffee